import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';
import { Alert, TitleText } from '../../../components';

const StepSuccess = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <TitleText mb="32px">{t('Sign In')}</TitleText>
      <Alert status="success">{t('Sign up Success')}</Alert>
    </Box>
  );
};

export default StepSuccess;
